<div class="main">
    <br>
    <div class="page-body">
        <app-mat-data-grid 
            class="page-data-grid"
            [searchBarEnabled]="false"
            [formValid]="formValid"
            [header]="audioPlayer"
            [(dataSource)]="data" 
            [displayedColumns]="['ctr.Attributes.policyNumber', 'dateOfCall', 'timeOfCall', 'ctr.Attributes.disposition', 'callLength']"
            [columnNames]="['Policy Number', 'Date of Call', 'Time of Call', 'Disposition', 'Call Length']"
            [buttonConfig]="{
                play: {output:'play', template:playButton},
                edit: {show: false},
                delete: {show: false}
            }"
            [objectBluePrint]="bluePrint"
            (buttonClick)="handleButtonEvent($event);">
        </app-mat-data-grid>

        <ng-template #playButton><mat-icon>play_circle_outline</mat-icon></ng-template>

        <ng-template #audioPlayer>
            <input class="small" type="text" placeholder="Search" [(ngModel)]="policyNumber" (ngModelChange)="getRecordings()">
            <audio
                controls 
                autoplay
                controlsList="nodownload"
                [src]="audioURL">
                    Your browser does not support the
                    <code>audio</code> element.
            </audio>
        </ng-template>
    </div>
</div>